import React from 'react';
import styled from 'styled-components';

import mq from '../../../styles/breakpoints';
import Spacings from '../../../styles/Spacings';

import Radiusses from '../../../tokens/Radiusses';

import { PaperProps } from './Paper.types';

const Paper = ({
  radiusTopLeft = Radiusses.M,
  radiusTopRight = Radiusses.M,
  radiusBottomLeft = Radiusses.M,
  radiusBottomRight = Radiusses.M,
  ...props
}: PaperProps) => (
  <StyledPaper
    radiusTopLeft={radiusTopLeft}
    radiusTopRight={radiusTopRight}
    radiusBottomLeft={radiusBottomLeft}
    radiusBottomRight={radiusBottomRight}
    {...props}
  />
);

const StyledPaper = styled.div<PaperProps>`
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.paper.backgroundColor};
  border-bottom-left-radius: ${({ radiusBottomLeft }) => radiusBottomLeft};
  border-bottom-right-radius: ${({ radiusBottomRight }) => radiusBottomRight};
  border-top-left-radius: ${({ radiusTopLeft }) => radiusTopLeft};
  border-top-right-radius: ${({ radiusTopRight }) => radiusTopRight};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationWell};
  padding: ${Spacings.S};

  ${mq.from.breakpoint.M`
    padding: ${Spacings.M};
  `}

  ${mq.from.breakpoint.L`
    padding: ${Spacings.L};
  `}

  ${mq.from.breakpoint.XL`
    padding: ${Spacings.XL};
  `}
`;

export default Paper;
